module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/1d2c814e685e7338e51d368479f69bd9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_info_hover.svg
// module id = JPJw
// module chunks = 1